import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '@pos-app/core-ui';
import { PIBEmailDetails, PIBEmailList } from '@pos-app/data/lib/models/email';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { LoadCentralTasks, LoadOpenJobRequestTotals, LoadTaskDetails, SaveActiveNavIndex } from '../../+state/central.actions';
import { CentralPartialState } from '../../+state/central.reducer';
import { Task, TaskDetail } from '../../model/task';
import { centralQuery } from '../../+state/central.selectors';
import { takeUntil } from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';
import { NgIf, NgFor } from '@angular/common';
import { MatBadge } from '@angular/material/badge';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-central-tasks',
    templateUrl: './central-notification.component.html',
    styleUrls: ['./central-notification.component.scss'],
    imports: [NgIf, MatBadge, MatIcon, NgFor]
})
export class CentralNotificationComponent implements OnInit {
  @ViewChild('productInfoBulletinEmailDetailContent') productInfoBulletinEmailDetailContent: any;
  //filter
  allSites = true;
  justMine = false;
  //pagination
  page = 1;
  pageSize = 5;
  collectionSize = 0;
  paginateData: any[] = [];
  //end pagination
  title = 'MANAGE MY TASKS';
  showEmptyMessage = 'No urgent notifications found';
  emailListMatIcon = 'alarm';
  emailNotificationList: Task[] = [];
  showTaskDetails = false;
  isShowTaskSummary = false;
  hover: boolean = false;

  private _loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loading$ = this._loadingSubject.asObservable();
  get loading(): boolean {
    return this._loadingSubject.value;
  }
  set loading(v: boolean) {
    this._loadingSubject.next(v);
  }
  taskDetail: TaskDetail;
  taskTotalsData: any;
  notificationNavs = [
    { label: 'Assigned To Me', badgeCount: 0 },
    { label: 'My Overdue', badgeCount: 0 },
    { label: 'Updates', badgeCount: 0 },
    { label: 'Unassigned', badgeCount: 0 },
    { label: 'Site Overdue', badgeCount: 0 },
  ];
  activeNavIndex = 0;
  hoverNavIndex = -1;
  private unSubscribe$ = new Subject<void>();

  constructor(private apiService: ApiService, private toastr: ToastrService, private router: Router, private store: Store<CentralPartialState>) {}

  ngOnInit() {
    this.initializeData();
  }

  initializeData() {
    this.store.dispatch(new LoadCentralTasks());
    this.store.dispatch(new LoadOpenJobRequestTotals());
    this.store.pipe(select(centralQuery.getCentralTaskData), takeUntil(this.unSubscribe$)).subscribe((data) => {
      if (data) {
        this.taskTotalsData = data;

        //update badge count
        this.notificationNavs[0].badgeCount = this.taskTotalsData.AssignedToMeTotal;
        this.notificationNavs[1].badgeCount = this.taskTotalsData.MyOverdueTotal;
        this.notificationNavs[2].badgeCount = this.taskTotalsData.TicketAcknowledgementTotal;
        this.notificationNavs[3].badgeCount = this.taskTotalsData.UnassignedTicketsTotal;
        this.notificationNavs[4].badgeCount = this.taskTotalsData.SiteOverdueTotal;
      }
    });
  }

  toggleJustMine(justMineView: boolean) {
    this.allSites = !this.allSites;
    this.justMine = justMineView;
    this.initializeData();
  }

  getPaginationData() {
    const start = (this.page - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.paginateData = this.emailNotificationList.slice(start, end);
  }

  selectPage(page: string) {
    this.page = parseInt(page, 10) || 1;
  }

  showSelectedEmailDetails(emailDetails: PIBEmailDetails) {
    //TODO: Implement this method
  }
  getShortDate(date: string): string {
    const lastSlashIndex = date.lastIndexOf('/');
    return lastSlashIndex !== -1 ? date.substring(0, lastSlashIndex) : date;
  }

  getInShortDescRequestor(email: string): string {
    const atIndex = email.lastIndexOf('@');
    return atIndex !== -1 ? email.substring(0, atIndex) : email;
  }
  updateCompleteStatus(task: Task) {
    this.apiService.acknowledgeTaskUpdate({ UKID: task.UKID }).subscribe((data) => {
      if (data.ErrorFlag === '0') {
        this.toastr.success('Acknowledge of Task updated successfully');
        this.initializeData();
      } else {
        this.toastr.error(data.ErrorMessage);
      }
    });
  }

  showTaskDetail(task: Task) {
    this.store.dispatch(new LoadTaskDetails(task.UKID));
    this.navigateTo(`/central/task/detail/${task.UKID}`);
  }

  navigateTo(url) {
    this.router.navigateByUrl(url);
  }
  setActiveNav(index: number): void {
    this.store.dispatch(new SaveActiveNavIndex(index));
    this.navigateTo(`/central/tasks`);
  }
  showTaskSummary() {
    this.isShowTaskSummary = !this.isShowTaskSummary;
  }

  goToTask() {
    this.router.navigateByUrl('/central/tasks');
  }
}

